import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import "../styles/layout.css";

export default function Layout() {
  return (
    <div className="app-layout">
      <div className="app-layout__sidebar">
        <Sidebar />
      </div>

      <main className="app-layout__content">
        <Outlet />
      </main>

    </div>
  );
}
